import { Card, Divider, Stack } from "@towersystems/roam-common-native";
import { InvoiceArrivalDetailsFormProvider } from "./InvoiceArrivalDetailsFormProvider";
import {
  InvoiceArrivalDateFormInput,
  InvoiceDateFormInput,
  InvoiceDueDateFormInput,
  InvoiceNumberFormInput,
  InvoiceIncGstFormInput,
  OrderNumberFormInput,
} from "./components";

export interface InvoiceArrivalDetailsFormProps {}

export const InvoiceArrivalDetailsForm =
  ({}: InvoiceArrivalDetailsFormProps) => {
    return (
      <Stack vertical>
        <Card title="INVOICE DETAILS">
          <Stack vertical>
            <InvoiceNumberFormInput />
            <OrderNumberFormInput />
            <Divider marginVertical={0} />
            <InvoiceIncGstFormInput />
            <Divider marginVertical={0} />
            <InvoiceDateFormInput />
            <InvoiceArrivalDateFormInput />
            <InvoiceDueDateFormInput />
          </Stack>
        </Card>
      </Stack>
    );
  };

InvoiceArrivalDetailsForm.Provider = InvoiceArrivalDetailsFormProvider;
